import { PortableText, PortableTextTypeComponent } from '@portabletext/react'
import { ArbitraryTypedObject } from '@portabletext/types'
import React from 'react'

export type BlockAreaProps = {
  componentTypes: Record<string, PortableTextTypeComponent>
  value: ArbitraryTypedObject[]
}

export const BlockArea = ({ componentTypes, value }: BlockAreaProps) => (
  <PortableText
    components={{
      types: componentTypes,
    }}
    value={value}
  />
)
